import { useMemo } from "react";
import { Chip } from "@mui/material";
import { IconEye } from "@tabler/icons-react";
import VirtualizedTable from "../components/VirtualizeTable";
import { MRT_ColumnDef } from "material-react-table";
import { formatPhone } from "../helpers/format";
import { useStudentModalStore } from "../stores/studentModal";

const StudentTableComponent = ({
  data,
}: {
  data: Array<{
    id: string;
    fullName: string;
    email?: string;
    phone: string;
    createdAt: string | Date;
    status: string;
    payment: [];
    studentOnPlan: [];
    statusPayment?: string;
    statusPlan?: string;
    belts?: string;
  }>;
  refetch?: () => void;
}) => {
  const openStudent = useStudentModalStore((s) => s.openModal);

  const columns = useMemo<MRT_ColumnDef<(typeof data)[0]>[]>(() => {
    return [
      {
        accessorKey: "fullName",
        header: "Nome",
        muiTableHeadCellProps: { align: "center", sx: { textAlign: "center" } },
        muiTableBodyCellProps: { align: "center", sx: { textAlign: "center" } },
      },
      {
        accessorKey: "phone",
        header: "Telefone",
        Cell: ({ cell }) => formatPhone(cell.getValue() as string) || "--",
        muiTableHeadCellProps: { align: "center", sx: { textAlign: "center" } },
        muiTableBodyCellProps: { align: "center", sx: { textAlign: "center" } },
      },
      {
        accessorKey: "statusPayment",
        header: "Pagamento",
        Cell: ({ cell }) => {
          const status = cell.getValue() as string;
          const color = status === "Pagamentos em dia" ? "success" : "warning";
          return (
            <Chip
              label={status}
              color={color}
              sx={{ color: "#fff", width: "100%" }}
            />
          );
        },
        muiTableHeadCellProps: { align: "center", sx: { textAlign: "center" } },
        muiTableBodyCellProps: { align: "center", sx: { textAlign: "center" } },
      },
      {
        accessorKey: "statusPlan",
        header: "Plano ativo?",
        size: 120,
        Cell: ({ cell }) => {
          const status = cell.getValue() as string;
          const color = status === "Sim" ? "success" : "error";
          return (
            <Chip
              label={status}
              color={color}
              sx={{ color: "#fff", width: "100%" }}
            />
          );
        },
        muiTableHeadCellProps: { align: "center", sx: { textAlign: "center" } },
        muiTableBodyCellProps: { align: "center", sx: { textAlign: "center" } },
      },
      {
        id: "detalhes",
        header: "Detalhes",
        size: 80,
        Cell: ({ row }) => {
          return (
            <IconEye
              onClick={() => {
                openStudent({ id: Number(row.original.id) });
              }}
              style={{ cursor: "pointer", color: "#FFF" }}
            />
          );
        },
        muiTableHeadCellProps: { align: "center", sx: { textAlign: "center" } },
        muiTableBodyCellProps: { align: "center", sx: { textAlign: "center" } },
      },
    ];
  }, [data]);

  return (
    <>
      <VirtualizedTable
        data={data}
        columns={columns}
        fetchNextPage={() => Promise.resolve()}
        isLoading={false}
      />
    </>
  );
};

export default StudentTableComponent;
